var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"section8"}},[_c('tUnis',{attrs:{"titles":_vm.p1s8titles,"unis":_vm.p1s8items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }